import { z } from "zod";

const axiosErrorSchema = z.object({
  response: z.object({
    data: z.object({
      status: z.number(),
      success: z.boolean(),
      error: z.object({
        code: z.string(),
        hash: z.string().optional(),
        user: z
          .object({
            hash: z.string(),
            source: z.string(),
            email: z.string(),
            firstName: z.string(),
            lastName: z.string(),
          })
          .optional()
          .catch(undefined),
        message: z.string(),
        fields: z
          .record(z.string(), z.array(z.string()))
          .optional()
          .or(z.undefined()),
      }),
    }),
  }),
});

export type AxiosErrorType = z.infer<typeof axiosErrorSchema>;

export const validateError = (data: unknown) => {
  const parsedError = axiosErrorSchema.safeParse(data);

  if (parsedError.success) return parsedError.data;

  return undefined;
};

export const parseApiErrorMessage = (
  error: unknown,
  fallback = "Something went wrong. Please try again.",
): string => {
  const parsed = validateError(error);
  const fields = parsed?.response.data.error.fields;
  const fieldMessages = fields ? Object.values(fields).flat().join(" ") : null;
  return fieldMessages ?? parsed?.response.data.error.message ?? fallback;
};
